import type { HealthLabel } from '../../../services/analysis';

// Layout variant: 'full' for the patient-files tab, 'slim' for narrow sidebars.
export type AnalysisVariant = 'full' | 'slim';

// Visual tokens per health label (ring/track are hex because they feed SVG
// stroke attributes; the rest are Tailwind classes).
export interface HealthTheme {
    label: string;
    ring: string;
    track: string;
    text: string;
    bg: string;
    dot: string;
}

export const HEALTH: Record<HealthLabel, HealthTheme> = {
    on_track: {
        label: 'On track',
        ring: '#10b981',
        track: '#d1fae5',
        text: 'text-emerald-700',
        bg: 'bg-emerald-50',
        dot: 'bg-emerald-500'
    },
    needs_attention: {
        label: 'Needs attention',
        ring: '#f59e0b',
        track: '#fef3c7',
        text: 'text-amber-700',
        bg: 'bg-amber-50',
        dot: 'bg-amber-500'
    },
    at_risk: {
        label: 'At risk',
        ring: '#ef4444',
        track: '#fee2e2',
        text: 'text-red-700',
        bg: 'bg-red-50',
        dot: 'bg-red-500'
    }
};

const UNKNOWN_HEALTH: HealthTheme = {
    label: 'Unknown',
    ring: '#9ca3af',
    track: '#e5e7eb',
    text: 'text-gray-600',
    bg: 'bg-gray-100',
    dot: 'bg-gray-400'
};

export function healthTheme(label: HealthLabel | null | undefined): HealthTheme {
    return (label && HEALTH[label]) || UNKNOWN_HEALTH;
}
